// extracted by mini-css-extract-plugin
export default {"productDescription":"Gda-z","featuredDescription":"Hda-z","description":"Ida-z","more":"Jda-z","descriptionSku":"Kda-z"};